import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

Swiper.use([Navigation, Pagination, Autoplay]);

// Basic Slider
var swiper = new Swiper(".basic-slider", {
  loop: true,
  autoplay: {
    delay: 5000,
  },
  speed: 500,
  navigation: {
    enabled: false,
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    768: {
      navigation: {
        enabled: true,
      },
    },
  }
});

// Testimonial Slider
var swiper = new Swiper(".testimonial-slider", {
  loop: true,
  autoplay: {
    delay: 5000,
  },
  speed: 500,
  navigation: {
    enabled: false,
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    768: {
      navigation: {
        enabled: true,
      },
    },
  }
});

document.querySelectorAll(".testimonial-slider-cards").forEach(function (el) {
  // Desktop slide count is configurable via data-desktop-slides (1, 2 or 3). Defaults to 3.
  var desktopSlides = parseInt(el.dataset.desktopSlides, 10);
  if (!desktopSlides || desktopSlides < 1 || desktopSlides > 3) {
    desktopSlides = 3;
  }
  // Never show more on tablet than on desktop.
  var tabletSlides = Math.min(desktopSlides, 2);
  var slideCount = el.querySelectorAll(".swiper-slide").length;
  var maxSlidesPerView = Math.max(desktopSlides, tabletSlides, 1);
  var enableLoop = slideCount > maxSlidesPerView;

  new Swiper(el, {
    loop: enableLoop,
    slidesPerView: 1,
    spaceBetween: 22,
    autoplay: {
      delay: 5000,
    },
    speed: 500,
    navigation: {
      enabled: true,
      nextEl: el.querySelector(".swiper-button-next"),
      prevEl: el.querySelector(".swiper-button-prev"),
    },
    breakpoints: {
      768: {
        slidesPerView: tabletSlides,
      },
      992: {
        slidesPerView: desktopSlides,
      },
    },
  });
});

// Basic Carousel
var swiper = new Swiper(".basic-carousel", {
  slidesPerView: 2,
  autoplay: {
    delay: 5000,
  },
  speed: 500,
  navigation: {
    enabled: false,
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    580: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 4,
      navigation: {
        enabled: true,
      },
    },
    992: {
      slidesPerView: 5,
      navigation: {
        enabled: true,
      },
    }
  }
});

// Hero Slider
var swiper = new Swiper(".hero-slider", {
  loop: true,
  autoplay: {
    delay: 5000,
  },
  speed: 500,
  navigation: {
    enabled: false,
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
  },
  breakpoints: {
    768: {
      navigation: {
        enabled: true,
      },
    },
  }
});
